// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.markValidFields--wrapper {
  padding: 0 36px;
  width: 100%;
}
.markValidFields--contents {
  background: #fff;
  border-radius: 22px;
}
.markValidFields--headingWrapper {
  padding: 19px 24px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #edf0f2;
}
.markValidFields--headingWrapper h2 {
  font-size: 20px;
}
.markValidFields--actionBtn {
  font-size: 14px;
  font-weight: 500;
  padding: 8px 20px;
  margin-left: 15px;
}
.markValidFields--carrierContentsWrapper {
  padding: 19px 24px;
  margin-bottom: 20px;
}
.markValidFields--carrierContents {
  padding: 0 5px;
}
.markValidFields--carrierName {
  color: #222222;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.markValidFields--carrierFieldsWrapper {
  margin-bottom: 25px;
}
.markValidFields--carrierFieldsLabel {
  font-size: 14px;
  color: #505050;
  line-height: 1.5;
  display: inline-block;
}
.markValidFields--progressBar {
  margin-bottom: 15px;
}
.markValidFields--status {
  font-size: 16px;
  color: #119f58;
  font-weight: 500;
  display: flex;
  align-items: center;
  margin-left: 20px;
}
.markValidFields--statusImg {
  margin-right: 5px;
  height: 17p;
}
.markValidFields--breadcrumb {
  padding: 0 10px;
}
.markValidFields--inputCheck {
  display: none;
}
.markValidFields--unchecked {
  display: inline-block;
  height: 18px;
  width: 18px;
  border: 1.5px solid #dedede;
  border-radius: 2px;
  margin-right: 10px;
  vertical-align: top;
}
.markValidFields--checked {
  display: none;
  margin-right: 10px;
  width: 18px;
  vertical-align: top;
}
.markValidFields--inputCheck:checked
  + .markValidFields--carrierFieldsLabel
  .markValidFields--checked {
  display: inline-block;
}
.markValidFields--inputCheck:checked
  + .markValidFields--carrierFieldsLabel
  .markValidFields--unchecked {
  display: none;
}
.markValidFields--checkboxLabel {
  vertical-align: top;
  display: inline-block;
  line-height: 18px;
  max-width: calc(100% - 28px);
}
.markValidFields--carrierKeysWrapper {
  height: calc(100vh - 300px);
  overflow-y: auto;
}
.markValidFields--carrierContentsWrapper
  .pagination--wrapper
  .pagination--info {
  width: 20%;
}

.markValidFields--carrierContentsWrapper .pagination--wrapper .pagination {
  width: 80%;
}
.markValidFields--carrierContentsWrapper .pagination--numbersWrapper {
  max-width: calc(100% - 90px);
  display: flex;
  overflow-x: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/carrierOnboard/markValidFields/markValidFields.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;AACA;;;EAGE,qBAAqB;AACvB;AACA;;;EAGE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;;;EAGE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".markValidFields--wrapper {\n  padding: 0 36px;\n  width: 100%;\n}\n.markValidFields--contents {\n  background: #fff;\n  border-radius: 22px;\n}\n.markValidFields--headingWrapper {\n  padding: 19px 24px;\n  display: flex;\n  display: -webkit-flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #edf0f2;\n}\n.markValidFields--headingWrapper h2 {\n  font-size: 20px;\n}\n.markValidFields--actionBtn {\n  font-size: 14px;\n  font-weight: 500;\n  padding: 8px 20px;\n  margin-left: 15px;\n}\n.markValidFields--carrierContentsWrapper {\n  padding: 19px 24px;\n  margin-bottom: 20px;\n}\n.markValidFields--carrierContents {\n  padding: 0 5px;\n}\n.markValidFields--carrierName {\n  color: #222222;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.5;\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.markValidFields--carrierFieldsWrapper {\n  margin-bottom: 25px;\n}\n.markValidFields--carrierFieldsLabel {\n  font-size: 14px;\n  color: #505050;\n  line-height: 1.5;\n  display: inline-block;\n}\n.markValidFields--progressBar {\n  margin-bottom: 15px;\n}\n.markValidFields--status {\n  font-size: 16px;\n  color: #119f58;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  margin-left: 20px;\n}\n.markValidFields--statusImg {\n  margin-right: 5px;\n  height: 17p;\n}\n.markValidFields--breadcrumb {\n  padding: 0 10px;\n}\n.markValidFields--inputCheck {\n  display: none;\n}\n.markValidFields--unchecked {\n  display: inline-block;\n  height: 18px;\n  width: 18px;\n  border: 1.5px solid #dedede;\n  border-radius: 2px;\n  margin-right: 10px;\n  vertical-align: top;\n}\n.markValidFields--checked {\n  display: none;\n  margin-right: 10px;\n  width: 18px;\n  vertical-align: top;\n}\n.markValidFields--inputCheck:checked\n  + .markValidFields--carrierFieldsLabel\n  .markValidFields--checked {\n  display: inline-block;\n}\n.markValidFields--inputCheck:checked\n  + .markValidFields--carrierFieldsLabel\n  .markValidFields--unchecked {\n  display: none;\n}\n.markValidFields--checkboxLabel {\n  vertical-align: top;\n  display: inline-block;\n  line-height: 18px;\n  max-width: calc(100% - 28px);\n}\n.markValidFields--carrierKeysWrapper {\n  height: calc(100vh - 300px);\n  overflow-y: auto;\n}\n.markValidFields--carrierContentsWrapper\n  .pagination--wrapper\n  .pagination--info {\n  width: 20%;\n}\n\n.markValidFields--carrierContentsWrapper .pagination--wrapper .pagination {\n  width: 80%;\n}\n.markValidFields--carrierContentsWrapper .pagination--numbersWrapper {\n  max-width: calc(100% - 90px);\n  display: flex;\n  overflow-x: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
